import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import EtfExplorer from "../components/EtfExplorer";

export default function FreeHome() {
  return (
    <EtfExplorer
      title="Explore ETF Details"
      subtitle="Browse ETFs from a collapsible filter rail, use the asset tree to pick the last category node, then open each fund for full details."
      cta={
        <Button component={Link} to="/register" variant="contained">
          Create account
        </Button>
      }
    />
  );
}
